/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  ThemeProvider,
} from "@mui/material";
import { CRUDFormPageProps } from "../../types";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// import { usePagePermissions } from "../../Components/PagePermission";
import { BASE_API_URL } from "../../API/Base";
import AxiosInstance from "../../API/axios";
import toast from "react-hot-toast";
import theme from "../../theme";
import Layout from "../../Components/Layout";

const CRUDForm: React.FC<CRUDFormPageProps> = ({ mode, data, fields }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [statusType, setStatusType] = useState<any>([]);
  const [selectedStatusType, setSelectedStatusType] = useState<any>(null);
  const [editedValues, setEditedValues] = useState<any>({});
  const [formData, setFormData] = useState({
    Status_Name: "",
    Status_Type: "",
    IsStatus: true,
  });

  const navigate = useNavigate();
  // const permissions = usePagePermissions(20);
  // const theme: Theme = useThemeStore((state) => state.theme);

  const handleInputChange = (key: string, value: any) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const fetchStatusType = async () => {
    try {
      const response = await AxiosInstance.get(
        `${BASE_API_URL}/admin/status/v1/get-status-type`
      );
      setStatusType(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchStatusType();

    if (mode === "edit" && data) {
      setEditedValues(data);

      setFormData({
        Status_Name: data.Status_Name || "",
        Status_Type: data.Status_Type || "",
        IsStatus: data.IsStatus || "",
      });

      setSelectedStatusType(data.Status_Type);
    }
  }, [mode, data]);

  const handleSubmit = async () => {
    try {
      if (mode === "create") {
        const newData = {
          Status_Name: formData.Status_Name,
          Status_Type: formData.Status_Type,
          IsStatus: 1,
          Parent_Module_Id: 0,
        };

        const response = await AxiosInstance.post(
          `${BASE_API_URL}/admin/status/v1/status`,
          newData
        );
        if (response.data) {
          toast.success("Status created successfully");
          // logEvent(
          //   20,
          //   permissions?.Add?.id,
          //   response.data.status_id.toString()
          // );
        }
      } else if (mode === "edit") {
        const newData = {
          Status_Name: formData.Status_Name,
          Status_Type: formData.Status_Type,
          IsStatus: !!formData.IsStatus,
        };

        const response = await AxiosInstance.put(
          `${BASE_API_URL}/admin/status/v1/status/${editedValues.Id}`,
          newData
        );

        if (response.data) {
          toast.success("Status updated successfully");
          // logEvent(20, permissions?.Update?.id, editedValues.Id.toString());
        }
      }
    } catch (error: any) {
      if (error.response) {
        if (error.response.status === 400) {
          toast.error(error.response.data.detail || "Bad Request");
        } else {
          // Handle other error status codes
          toast.error(`Server Error: ${error.response.status}`);
        }
      } else if (error.request) {
        toast.error("No response received from the server");
      } else {
        toast.error("Error setting up the request");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout PageId={5}>
      <ThemeProvider theme={theme}>
        {loading && (
          <Box
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",

              zIndex: 1000,
            }}
          >
            <CircularProgress size={50} />
          </Box>
        )}

        <div className="flex flex-col items-start justify-start w-full h-full mt-4">
          <Grid container spacing={2}>
            {mode === "create" && (
              <>
                <Grid item xs={6}>
                  <TextField
                    label="Status Name"
                    variant="outlined"
                    fullWidth
                    margin="dense"
                    size="small"
                    required
                    value={formData.Status_Name}
                    onChange={(e) =>
                      handleInputChange("Status_Name", e.target.value)
                    }
                    sx={{
                      backgroundColor: "#fff",
                      borderRadius: "10px",
                      "& .MuiInputLabel-root": {
                        color: "#000",
                        "&.Mui-focused": {
                          color: "#000",
                        },
                      },
                      "& .MuiInputLabel-shrink": {
                        color: "#00A99D",
                      },
                      "& .MuiOutlinedInput-root": {
                        // "& fieldset": {
                        //   borderColor:  "#00A99D" : "",
                        // },
                        // "&:hover fieldset": {
                        //   borderColor:  "#00A99D" : "",
                        // },

                        "& .MuiInputBase-input": {
                          color: "#000",
                          fontSize: "14px",
                        },
                        "& .MuiSelect-icon": {
                          fill: "#000 !important",
                        },
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={6}>
                  <FormControl
                    fullWidth
                    variant="outlined"
                    margin="dense"
                    size="small"
                    sx={{
                      backgroundColor: "#fff",
                      borderRadius: "10px",
                      "& .MuiInputLabel-root": {
                        color: "#000",
                        "&.Mui-focused": {
                          color: "#000",
                        },
                      },
                      "& .MuiInputLabel-shrink": {
                        color: "#00A99D",
                      },
                      "& .MuiOutlinedInput-root": {
                        // "& fieldset": {
                        //   borderColor:  "#00A99D" : "",
                        // },
                        // "&:hover fieldset": {
                        //   borderColor:  "#00A99D" : "",
                        // },

                        "& .MuiInputBase-input": {
                          color: "#000",
                          fontSize: "14px",
                        },
                        "& .MuiSelect-icon": {
                          fill: "#000 !important",
                        },
                      },
                    }}
                  >
                    <InputLabel>Status type</InputLabel>
                    <Select
                      value={formData.Status_Type || ""}
                      label="Status type"
                      required
                      onChange={(e) =>
                        handleInputChange("Status_Type", e.target.value)
                      }
                    >
                      {statusType?.flatMap((status: any) =>
                        status.Description.map((item: any, index: number) => [
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>,
                        ])
                      )}
                    </Select>
                  </FormControl>
                </Grid>
              </>
            )}
            {mode === "view" && (
              <>
                {fields.map(({ label, key, type }) => (
                  <Grid item xs={6} key={key}>
                    <TextField
                      key={key}
                      label={label}
                      variant="outlined"
                      fullWidth
                      margin="dense"
                      size="small"
                      value={data[key] || ""}
                      sx={{
                        backgroundColor: "#fff",
                        borderRadius: "10px",
                        "& .MuiInputLabel-root": {
                          color: "#000",
                          "&.Mui-focused": {
                            color: "#000",
                          },
                        },
                        "& .MuiInputLabel-shrink": {
                          color: "#00A99D",
                        },
                        "& .MuiOutlinedInput-root": {
                          // "& fieldset": {
                          //   borderColor:  "#00A99D" : "",
                          // },
                          // "&:hover fieldset": {
                          //   borderColor:  "#00A99D" : "",
                          // },

                          "& .MuiInputBase-input": {
                            color: "#000",
                            fontSize: "14px",
                          },
                          "& .MuiSelect-icon": {
                            fill: "#000 !important",
                          },
                        },
                      }}
                    />
                  </Grid>
                ))}
              </>
            )}
            {mode === "edit" && (
              <>
                <Grid item xs={6}>
                  <TextField
                    label="Status Name"
                    variant="outlined"
                    margin="dense"
                    size="small"
                    required
                    value={formData.Status_Name || ""}
                    onChange={(e) =>
                      handleInputChange("Status_Name", e.target.value)
                    }
                    fullWidth
                    sx={{
                      backgroundColor: "#fff",
                      borderRadius: "10px",
                      "& .MuiInputLabel-root": {
                        color: "#000",
                        "&.Mui-focused": {
                          color: "#000",
                        },
                      },
                      "& .MuiInputLabel-shrink": {
                        color: "#00A99D",
                      },
                      "& .MuiOutlinedInput-root": {
                        // "& fieldset": {
                        //   borderColor:  "#00A99D" : "",
                        // },
                        // "&:hover fieldset": {
                        //   borderColor:  "#00A99D" : "",
                        // },

                        "& .MuiInputBase-input": {
                          color: "#000",
                          fontSize: "14px",
                        },
                        "& .MuiSelect-icon": {
                          fill: "#000 !important",
                        },
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={6}>
                  <FormControl
                    fullWidth
                    variant="outlined"
                    margin="dense"
                    size="small"
                    sx={{
                      backgroundColor: "#fff",
                      borderRadius: "10px",
                      "& .MuiInputLabel-root": {
                        color: "#000",
                        "&.Mui-focused": {
                          color: "#000",
                        },
                      },
                      "& .MuiInputLabel-shrink": {
                        color: "#00A99D",
                      },
                      "& .MuiOutlinedInput-root": {
                        // "& fieldset": {
                        //   borderColor:  "#00A99D" : "",
                        // },
                        // "&:hover fieldset": {
                        //   borderColor:  "#00A99D" : "",
                        // },

                        "& .MuiInputBase-input": {
                          color: "#000",
                          fontSize: "14px",
                        },
                        "& .MuiSelect-icon": {
                          fill: "#000 !important",
                        },
                      },
                    }}
                  >
                    <InputLabel>Status type</InputLabel>
                    <Select
                      value={formData.Status_Type || ""}
                      label="Status type"
                      required
                      onChange={(e) =>
                        handleInputChange("Status_Type", e.target.value)
                      }
                    >
                      {statusType?.flatMap((status: any) =>
                        status.Description.map((item: any, index: number) => [
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>,
                        ])
                      )}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl
                    fullWidth
                    variant="outlined"
                    margin="dense"
                    size="small"
                    sx={{
                      backgroundColor: "#fff",
                      borderRadius: "10px",
                      "& .MuiInputLabel-root": {
                        color: "#000",
                        "&.Mui-focused": {
                          color: "#000",
                        },
                      },
                      "& .MuiInputLabel-shrink": {
                        color: "#00A99D",
                      },
                      "& .MuiOutlinedInput-root": {
                        // "& fieldset": {
                        //   borderColor:  "#00A99D" : "",
                        // },
                        // "&:hover fieldset": {
                        //   borderColor:  "#00A99D" : "",
                        // },

                        "& .MuiInputBase-input": {
                          color: "#000",
                          fontSize: "14px",
                        },
                        "& .MuiSelect-icon": {
                          fill: "#000 !important",
                        },
                      },
                    }}
                  >
                    <InputLabel>Status</InputLabel>
                    <Select
                      value={formData.IsStatus ? "true" : "false"}
                      required
                      label="Status"
                      onChange={(e) =>
                        handleInputChange(
                          "IsStatus",
                          e.target.value === "true" ? 1 : 0
                        )
                      }
                    >
                      <MenuItem value={"true"}>Active</MenuItem>
                      <MenuItem value={"false"}>Inactive</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </>
            )}
          </Grid>
          <div className="flex flex-row items-center justify-between w-full mt-4">
            {mode === "edit" && (
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                sx={{
                  color: "#fff",
                }}
              >
                Save Changes
              </Button>
            )}

            {mode === "create" && (
              <Button
                variant="contained"
                color="primary"
                sx={{
                  color: "#fff",
                }}
                onClick={handleSubmit}
              >
                Submit
              </Button>
            )}
            <Button
              variant="outlined"
              onClick={() => navigate("/status/manage")}
              sx={{
                color: "#000",
                border: "1px solid #000",
              }}
            >
              Back
            </Button>
          </div>
        </div>
      </ThemeProvider>
    </Layout>
  );
};

export default CRUDForm;
